import { PulseCircleAnimationMode } from 'enums';
import * as React from 'react';
import { Box } from 'wix-style-react';
import s from './CirclePulseAnimation.scss';

export interface CirclePulseAnimationProps {
  mode?: PulseCircleAnimationMode;
}

const circlePulseAnimationClassNames = {
  [PulseCircleAnimationMode.DEFAULT]: s.purpleCirclePulseAnimation,
  [PulseCircleAnimationMode.SALE]: s.orangeCirclePulseAnimation,
  [PulseCircleAnimationMode.CREDIT]: s.greenCirclePulseAnimation,
};

export const CirclePulseAnimation: React.FC<CirclePulseAnimationProps> = ({
  mode,
}) => {
  const classname = mode || PulseCircleAnimationMode.DEFAULT;
  return (
    <Box
      className={mode && circlePulseAnimationClassNames[classname]}
      dataHook='pulse-circle'
    ></Box>
  );
};
